module.exports = __webpack_public_path__ + "img/affiliate-streams.3d691bba.svg";